import { SideImage } from '../../components/SideImage';
import { PackageExperiencesContentPanel } from '../../composites/PackageExperiencesContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { PackageExperiencesTemplateProps } from './PackageExperiencesTemplate.types';

export function PackageExperiencesTemplate({
  imageUrl,
  imageAlt = '',
  ...panelProps
}: PackageExperiencesTemplateProps) {
  return (
    <SplitLayout
      leftWidth="45%"
      contentMaxWidth="660px"
      height="var(--layout-viewport-height, 100vh)"
      left={<SideImage src={imageUrl ?? undefined} alt={imageAlt} sticky />}
      right={<PackageExperiencesContentPanel {...panelProps} />}
    />
  );
}
